import React, { useState } from "react";
import { DialogTitle, Dialog, Button, TextField } from "@material-ui/core";
import { updateComment } from "../../services/comments.service";

export const ModalEditComment = ({ open, comment, setOpen }) => {
  const [contentComment, setContentComment] = useState(comment.content);

  const save = () => {
    console.log("here?");

    comment.content = contentComment;

    updateComment(comment)
      .then((response) => {
        console.log("response service comment", response);
        setOpen(false);
      })
      .catch((error) => {
        console.log("error ao atualizar comentário!", error);
      });
  };

  return (
    <Dialog
      fullWidth={true}
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="sm"
    >
      <DialogTitle>Ediar comentário</DialogTitle>
      <div style={{ padding: "20px" }}>
        {comment && comment.content && (
          <TextField
            fullWidth
            value={contentComment}
            onChange={(e) => setContentComment(e.target.value)}
            multiline
          />
        )}
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <Button onClick={save} color="primary" variant="contained">
            Atualizar
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
